import { ImageProps } from '../Image';

export type WowImageProps = ImageProps;
